import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import DOMPurify from 'isomorphic-dompurify'
import { TextPage } from 'routes/components/TextPage/TextPage'
import Text from 'md/referral-terms-and-conditions.md'

const ReferralTermsAndConditions = () => (
  <TextPage title="Customer referral program terms & conditions">
    <ReactMarkdown
      rehypePlugins={[rehypeRaw]}
      components={{
        a: ({ node: _node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" />,
      }}
    >
      {DOMPurify.sanitize(Text)}
    </ReactMarkdown>
  </TextPage>
)

export default ReferralTermsAndConditions
